import { baseUrl } from '../../utils/constants';
import { client } from '../client';
import { LOGIN, REQUESTOTP, VERIFYOTP } from '../endpoints';

export const signInApi = async ({
  email,
  password,
}: {
  email: string;
  password: string;
}) => {
  const response = await client.post(`${baseUrl}${LOGIN}`, { email, password });
  return response;
};

export const requestOtp = async ({
  mobileNumber,
  ipAddress,
}: {
  ipAddress: string;
  mobileNumber: string;
}) => {
  const response = await client.post(`${baseUrl}${REQUESTOTP}`, {
    mobileNumber,
    ipAddress,
  });
  return response;
};

export const verifyOtpCheck = async ({
  mobileNumber,
  otp,
  ipAddress,
}: {
  mobileNumber: string;
  otp: string;
  ipAddress: string;
}) => {
  const response = await client.post(`${baseUrl}${VERIFYOTP}`, {
    mobileNumber,
    otp,
    ipAddress,
  });
  return response;
};
